import { Injectable } from '@angular/core'
import { CanLoad, Route, UrlSegment } from '@angular/router'
import { Observable } from 'rxjs'
import { environment } from 'src/environments/environment'

@Injectable({
  providedIn: 'root'
})
export class PlaygroundGuard implements CanLoad {
  canLoad(route: Route, segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
    return environment.loadPlayground
  }
}
